"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const testAB_1 = require("modules/testAB");
const user_1 = require("../user");
const request_1 = __importDefault(require("@hotmart/request"));
class TestABService {
    async execute(testId) {
        try {
            const userId = user_1.UserStore.marketplaceId;
            const response = await (0, request_1.default)('testab.execute', {
                testId,
                transactionRef: userId
            });
            testAB_1.TestABStore.setCurrentCandidate(response.test.candidate);
        }
        catch (_a) { }
    }
    async convert(testId) {
        try {
            const userId = user_1.UserStore.marketplaceId;
            await (0, request_1.default)('testab.convert', {
                testId,
                transactionRef: userId
            });
        }
        catch (_a) { }
    }
}
__decorate([
    mobx_1.action
], TestABService.prototype, "execute", null);
exports.default = new TestABService();
